export default __webpack_public_path__ + "static/media/changeCamera.922f4286.png";